import api from './api';
import { PagamentoCorretagem, CreateMultiplePagamentosDTO, UpdatePagamentoCorretagemDTO, ResumoCorretagem } from '../types/pagamentoCorretagem';

class PagamentoCorretagemService {
    async findByApoliceId(apoliceId: number): Promise<PagamentoCorretagem[]> {
        const response = await api.get(`/pagamentos-corretagem/apolice/${apoliceId}`);
        return response.data.data;
    }

    async getResumoCorretagem(apoliceId: number): Promise<ResumoCorretagem> {
        const response = await api.get(`/pagamentos-corretagem/resumo/${apoliceId}`);
        return response.data.data;
    }

    async createMultiplePagamentos(data: CreateMultiplePagamentosDTO): Promise<PagamentoCorretagem[]> {
        const response = await api.post('/pagamentos-corretagem/create-multiple', data);
        return response.data.data;
    }

    async update(id: number, data: UpdatePagamentoCorretagemDTO): Promise<PagamentoCorretagem> {
        const response = await api.put(`/pagamentos-corretagem/${id}`, data);
        return response.data.data;
    }

    async delete(id: number): Promise<void> {
        await api.delete(`/pagamentos-corretagem/${id}`);
    }

    /**
     * Exclui múltiplos pagamentos de corretagem com base em uma lista de IDs.
     * @param ids - Um array de números representando os IDs a serem excluídos.
     */
    async deleteMultiple(ids: number[]): Promise<void> {
        // O endpoint do backend espera um POST com os IDs no corpo da requisição.
        await api.post('/pagamentos-corretagem/delete-multiple', { ids });
    }
}

export const pagamentoCorretagemService = new PagamentoCorretagemService();